<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-left" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
    <div class="row" >
      <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
    </div>
    <div class="row">
      <div class="col-md-2 offset-5">
        <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
      </div>
    </div>
  </div>
</div>

<div class="card bg-light" style="margin-top: 5px;">
  <div class="card-body"style="margin-bottom: 3px;">
    <div class="row">
      <div class="col-md-12 bold" style="text-align: center;"><h4>Agenda Category Order Dictionary</h4></div>
    </div>
    <br />
    <div class="card xl:flex xl:justify-content-center">
      <p-orderList
        [value]="agendaCategList"
        [listStyle]="{ 'max-height': '35rem' }"
        header="Agenda Categories - select an item, then drag and drop or use buttons on left side to reorder"
        [dragdrop]="true"
        (onReorder)="viewOrder()">
        <ng-template let-categ pTemplate="item">
          <div class="flex flex-wrap p-2 align-items-center gap-3" style="border-bottom: lightgray 1px solid; line-height: 8px;">
            <div class="flex-1 flex flex-column gap-2">
              <span class="font-bold">{{ categ.categoryDesc }}</span>
            </div>
          </div>
        </ng-template>
      </p-orderList>
    </div>
    <br />
    <div class="row">
      <div class="col-md-1 offset-1">
        <button class="btn btn-success" title="Save category order" (click)="saveCategoryOrder()">Save Order</button>
      </div>
      <div class="col-md-1 offset-1">
        <button class="btn btn-secondary" title="Cancel current changes and revert to previously saved order" (click)="cancelReOrder()">Cancel</button>
      </div>
    </div>
  </div>
</div>
